export default "__VITE_ASSET__BrDa$ROH__"